import { createI18n } from 'vue-i18n';
import fa from './lang/fa.json';
import en from './lang/en.json';

const i18n = createI18n({
    legacy: false, // اگر Composition API استفاده می‌کنی
    locale: 'fa', // زبان پیش‌فرض
    fallbackLocale: 'en', // در صورت نبود ترجمه، از انگلیسی استفاده شود
    globalInjection: true, // این خط را اضافه کن تا بتوانی $t را استفاده کنی
    messages: {
        fa,
        en
    }
});

export default i18n;